export function saveDocument(
  data: ArrayBuffer,
  filename: string,
  fileType: string
): void {
  if (data instanceof ArrayBuffer) {
    const blob = new Blob([data], { type: fileType });
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
  }
}

export function getBufferedArrayFor(str: string): ArrayBuffer {
  var buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  var bufView = new Uint16Array(buf);
  for (var i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}
